import { eModeCategoryIdToName } from '@/domain/e-mode/constants'
import { type MarketInfo } from '@/domain/market-info/marketInfo'
import { useMemo } from 'react'
import { type Address } from 'viem'
import { type CardMode, type MarketDataSource } from '../constants'
import { getPooledBorrowEModeMismatchMessage } from '../components/cardConfiguration.utils'

interface UsePooledBorrowEModeMismatchParams {
  marketDataSource: MarketDataSource
  mode: CardMode
  borrowTokenAddress?: Address
  marketInfo: MarketInfo
}

export function usePooledBorrowEModeMismatch({
  marketDataSource,
  mode,
  borrowTokenAddress,
  marketInfo,
}: UsePooledBorrowEModeMismatchParams) {
  const userEModeCategoryId = marketInfo.userConfiguration.eModeState.enabled
    ? marketInfo.userConfiguration.eModeState.category.id
    : 0

  const message = useMemo(() => {
    if (marketDataSource !== 'hypurrFi' || mode !== 'borrow' || !borrowTokenAddress) {
      return null
    }

    const borrowReserve = marketInfo.reserves.find(
      (reserve) => reserve.token.address.toLowerCase() === borrowTokenAddress.toLowerCase(),
    )
    const borrowAssetEModeCategoryId = borrowReserve?.eModeCategory?.id

    return getPooledBorrowEModeMismatchMessage({
      userEModeCategoryId,
      userEModeCategoryLabel: eModeCategoryIdToName[userEModeCategoryId],
      borrowAssetEModeCategoryId,
      borrowAssetEModeCategoryLabel:
        borrowAssetEModeCategoryId == null ? undefined : eModeCategoryIdToName[borrowAssetEModeCategoryId],
    })
  }, [marketDataSource, mode, borrowTokenAddress, marketInfo, userEModeCategoryId])

  return {
    message,
    hasMismatch: !!message,
    userEModeCategoryId,
  }
}
